import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CreditCard } from 'lucide-react';

export default function CardInputFields({ cardDetails, errors, processing, onChange }) {
  return (
    <>
      {/* Cardholder Name */}
      <div>
        <Label htmlFor="cardholder-name" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          Cardholder Name <span className="text-red-500">*</span>
        </Label>
        <Input
          id="cardholder-name"
          type="text"
          autoComplete="cc-name"
          value={cardDetails.cardholder_name}
          onChange={(e) => onChange('cardholder_name', e.target.value)}
          placeholder="JOHN DOE"
          className={`h-12 text-base ${errors.cardholder_name ? 'border-red-500' : ''}`}
          disabled={processing}
          data-testid="cardholder-name-input"
        />
        {errors.cardholder_name && (
          <p className="text-xs text-red-500 mt-1">{errors.cardholder_name}</p>
        )}
      </div>

      {/* Card Number */}
      <div>
        <Label htmlFor="card-number" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          Card Number <span className="text-red-500">*</span>
        </Label>
        <div className="relative">
          <Input
            id="card-number"
            type="text"
            inputMode="numeric"
            autoComplete="cc-number"
            value={cardDetails.card_number}
            onChange={(e) => onChange('card_number', e.target.value)}
            placeholder="4444 5555 6666 7777"
            className={`h-12 text-base pl-12 ${errors.card_number ? 'border-red-500' : ''}`}
            disabled={processing}
            data-testid="card-number-input"
          />
          <CreditCard className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        </div>
        {errors.card_number && (
          <p className="text-xs text-red-500 mt-1">{errors.card_number}</p>
        )}
      </div>

      {/* Expiry Date */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="expiry-month" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
            Expiry Month <span className="text-red-500">*</span>
          </Label>
          <Input
            id="expiry-month"
            type="text"
            inputMode="numeric"
            autoComplete="cc-exp-month"
            value={cardDetails.expiry_month}
            onChange={(e) => onChange('expiry_month', e.target.value)}
            placeholder="MM"
            maxLength={2}
            className={`h-12 text-base ${errors.expiry ? 'border-red-500' : ''}`}
            disabled={processing}
            data-testid="expiry-month-input"
          />
        </div>
        <div>
          <Label htmlFor="expiry-year" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
            Expiry Year <span className="text-red-500">*</span>
          </Label>
          <Input
            id="expiry-year"
            type="text"
            inputMode="numeric"
            autoComplete="cc-exp-year"
            value={cardDetails.expiry_year}
            onChange={(e) => onChange('expiry_year', e.target.value)}
            placeholder="YYYY"
            maxLength={4}
            className={`h-12 text-base ${errors.expiry ? 'border-red-500' : ''}`}
            disabled={processing}
            data-testid="expiry-year-input"
          />
        </div>
      </div>
      {errors.expiry && (
        <p className="text-xs text-red-500 -mt-3">{errors.expiry}</p>
      )}

      {/* CVV */}
      <div>
        <Label htmlFor="cvv" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
          CVV <span className="text-red-500">*</span>
        </Label>
        <Input
          id="cvv"
          type="text"
          inputMode="numeric"
          autoComplete="cc-csc"
          value={cardDetails.cvv}
          onChange={(e) => onChange('cvv', e.target.value)}
          placeholder="555"
          maxLength={4}
          className={`h-12 text-base ${errors.cvv ? 'border-red-500' : ''}`}
          disabled={processing}
          data-testid="cvv-input"
        />
        {errors.cvv && (
          <p className="text-xs text-red-500 mt-1">{errors.cvv}</p>
        )}
        <p className="text-xs text-muted-foreground mt-1">3 or 4 digits on the back of your card</p>
      </div>
    </>
  );
}
